import React from "react";
import { ConfigProvider, loadConfig } from "./lib/config";
import { IntlProvider } from "react-intl";
import { WhiteLabelProvider } from "./components/white-label-provider";
import { ThemeCustom } from "./components/theme-custom";

import messagesEn from "./translations/en.json";
import messagesEs from "./translations/es.json";
import { LocaleProvider } from "./components/locale-provider";
import { BrowserRouter } from "react-router-dom";
import Entry from "./modules/entry";
import { KeycloakProvider } from "./components/keycloak-provider";
import { BootstrapOverrides } from "./styling/bootstrap-overrides";
import { FullWidthLoader } from "./components/full-width-loader";
import { Toaster } from "react-hot-toast";

const config = loadConfig();

const messages: Record<string, Record<string, string>> = {
  "en-US": messagesEn,
  "es-ES": messagesEs,
};

function App() {
  return (
    <>
      <ConfigProvider value={config}>
        <WhiteLabelProvider>
          <ThemeCustom>
            <BootstrapOverrides />
            <KeycloakProvider LoadingComponent={<FullWidthLoader />}>
              <BrowserRouter basename="/v6/ng">
                <LocaleProvider>
                  {locale => (
                    <IntlProvider
                      locale={locale}
                      messages={messages[locale] ? messages[locale] : messages["en-US"]}
                      defaultLocale="en-US">
                      {/*This is the entry point for the application after all providers have been configured. */}
                      <Entry />
                      <Toaster position="bottom-center" />
                    </IntlProvider>
                  )}
                </LocaleProvider>
              </BrowserRouter>
            </KeycloakProvider>
          </ThemeCustom>
        </WhiteLabelProvider>
      </ConfigProvider>
    </>
  );
}
export default App;
